import { loadStripe } from "@stripe/stripe-js";
import { apiRequest } from "./util";
import { getStripePriceId, getOnboardingRoute } from "./prices";

let stripe;
// Load the Stripe script
loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY, {
  // Pin to specific version of the Stripe API
  // T-011.21: Updated from 2020-08-27 to 2024-09-30.acacia (Embedded Checkout support)
  apiVersion: "2024-09-30.acacia",
}).then((stripeInstance) => {
  // Set stripe so all functions below have it in scope
  stripe = stripeInstance;
});

export async function redirectToCheckout(planIds, options = {}) {
  // Build default success URL with product tracking params
  // planIds = ['qty', 'shortId'] — shortId is the product key before .map() transforms it
  const productId = planIds[1];
  const defaultRoute = getOnboardingRoute(productId);
  const defaultSuccessUrl = `${window.location.origin}${defaultRoute}?paid=true&product=${productId}&session_id={CHECKOUT_SESSION_ID}`;

  // Create a checkout session with optional metadata and promotion code
  const requestData = {
    priceIds: planIds.map((each, index) => index !== 0 ? getStripePriceId(each) : each),
    successUrl: options.successUrl || defaultSuccessUrl,
    cancelUrl: `${window.location.origin}/all`,
  };

  // T-011: Add customer data if provided (for lead capture flow)
  if (options.customerData) {
    requestData.customerData = options.customerData;
  }

  // Add optional metadata
  if (options.metadata) {
    requestData.metadata = options.metadata;
  }

  // Add optional promotion code
  if (options.promotionCode) {
    requestData.promotionCode = options.promotionCode;
  }

  // Add optional coupon code (legacy support)
  if (options.couponCode) {
    requestData.couponCode = options.couponCode;
  }

  const session = await apiRequest("stripe-create-checkout-session", "POST", requestData);

  // Ensure if user clicks browser back button from checkout they go to /all
  // instead of this page or they'll redirect right back to checkout.
  window.history.replaceState({}, "", "/all");

  // Redirect to checkout
  return await stripe.redirectToCheckout({
    sessionId: session.id,
  });
}

export async function redirectToBilling() {
  // Create a billing session
  const session = await apiRequest("stripe-create-billing-session", "POST", {
    returnUrl: `${window.location.origin}/settings/subscriptions`,
  });
  // Ensure if user clicks browser back button from billing they go to /settings/subscriptions
  // instead of this page or they'll redirect right back to billing.
  window.history.replaceState({}, "", "/settings/subscriptions");

  // Redirect to billing session url
  window.location.href = session.url;
}
